import React, { Component } from 'react';

import './Clients.css';

import en from '../../../language/en/Clients.json';
import es from '../../../language/es/Clients.json';

class Clients extends Component {
	constructor() {
		super();
		this.state = {
			config: {
				lang: {
					en: en,
					es: es
				}
			}
		};
	}

	render() {
		const lang = this.state.config.lang;
    	const selectedLanguage = (this.props.lang==='en')? lang.en: lang.es;

    	const companysLogo = selectedLanguage.companys.map((company, i) => {
    		return (
    			<div className="item" data-quote={"#" + company.id} key={ i }>
                	<img src={company.logo} alt="" />
                </div>
	        );
    	});

    	const companys = selectedLanguage.companys.map((company, i) => {
    		return (
    			<div key={ i } className="client-quote" id={company.id}>
                    <p>{company.serviceDescription}</p>
                    <h4>{company.name}</h4>
                    <span>{company.shortName}</span>
                </div>
	        );
    	});

		return (
			<section id="clients">
	            <div className="clients">
	                <div className="clients-bg">
	                    <div className="container">
	                        <div className="heading-blue">
	                            <h2><strong>{selectedLanguage.sectionTitle}</strong></h2>   
								<p>{selectedLanguage.sectionSubTitle}</p>	
	                        </div>

	                        
	                        <div className="owl-carousel">
	                            { companysLogo }                 	                           
	                        </div>
	                        
	                    </div>
	                </div>
	                
	                
	                <div className="clients-quotes">
	                    <div className="container">
	                        { companys }
	                    </div>
	                </div>
	                
	            </div>
	        </section>
		);
	}
}

export default Clients;